module.exports = __webpack_public_path__ + "img/Adv_perc_numbers-300x129.05b81df0.png";